import React, { ReactNode, useContext } from 'react';
import { View } from 'react-native';

import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  children,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size,
}: {
  children: ReactNode;
  size: 'lg' | 'md' | 'sm' | 'xl';
  placement:
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'left'
    | 'left-end'
    | 'left-start'
    | 'right'
    | 'right-end'
    | 'right-start'
    | 'top'
    | 'top-end'
    | 'top-start';
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  return (
    <View style={{ backgroundColor: colors.background[1000] }}>{children}</View>
  );
}
